import { useUserStore } from '@/stores/user/userStore';
import React, { useEffect } from 'react';
import DollarRewardIcon from '@/shared/icons/DollarRewardIcon';
import mixpanel from '@/utils/mixpanel';

const ReferralProgram = () => {
  const user = useUserStore(state => state.user);

  useEffect(() => {
    // Initialize Cello
    window.cello = window.cello || { cmd: [] };

    const celloBootParams = {
      productId: import.meta.env.VITE_CELLO_PRODUCT_ID,
      token: user?.cello_key?.token,
      language: "en",
      productUserDetails: {
        firstName: user?.firstName || user?.full_name?.split(' ')[0],
        lastName: user?.lastName || user?.full_name?.split(' ').slice(1).join(' '),
        email: user?.email || ''
      },
      customLauncher: '.cello-custom-launcher'
    };

    window.cello.cmd.push(async function (cello) {
      try {
        await cello.boot(celloBootParams);
      } catch (error) {
        console.error("Failed to boot cello:", error);
      }
    });
  }, [user]);


  return (
    <button className="cello-custom-launcher flex items-center duration-150 rounded-lg p-v3-xxs relative" onClick={() => mixpanel.track('Referral Program Clicked')}>
      <DollarRewardIcon className='text-[#10B981]'/>
      <p className="hidden sm:block font-medium text-sm whitespace-nowrap leading-5 text-black pl-v3-xs">Earn $100</p>
    </button>
  );
};

export default ReferralProgram;
